// ===============================================================
// File Library — Module Layout with sub-navigation
// ===============================================================

import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Group, Button } from '@mantine/core';
import {
  IconGauge, IconFolderOpen, IconSearch, IconCloudUpload, IconTags,
} from '@tabler/icons-react';
import { brand } from '../../lib/colors';
import Breadcrumbs from '../../components/ui/Breadcrumbs';

const NAV_ITEMS = [
  { label: 'Dashboard', path: '/filelibrary', icon: IconGauge, exact: true },
  { label: 'Browse', path: '/filelibrary/browse', icon: IconFolderOpen },
  { label: 'Search', path: '/filelibrary/search', icon: IconSearch },
  { label: 'Publish', path: '/filelibrary/publish', icon: IconCloudUpload },
  { label: 'Categories', path: '/filelibrary/categories', icon: IconTags },
];

export default function FileLibraryLayout() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const isDetail = pathname.match(/\/filelibrary\/doc\/\d/);

  const currentPage = NAV_ITEMS.find(item =>
    item.exact ? pathname === item.path : pathname.startsWith(item.path)
  );

  return (
    <div style={{ padding: '24px' }}>
      {!isDetail && (
        <>
        <Breadcrumbs
          items={[
            { label: 'Hub', to: '/' },
            { label: 'File Library', to: '/filelibrary' },
            ...(currentPage && currentPage.path !== '/filelibrary' ? [{ label: currentPage.label }] : []),
          ]}
        />
        <Group gap="xs" mb="md" style={{ borderBottom: '1px solid var(--frost)', paddingBottom: 12 }}>
          {NAV_ITEMS.map(item => {
            const active = item.exact ? pathname === item.path : pathname.startsWith(item.path);
            return (
              <Button
                key={item.path}
                variant={active ? 'filled' : 'light'}
                color={active ? brand.blurple : 'gray'}
                size="xs"
                leftSection={<item.icon size={14} />}
                onClick={() => navigate(item.path)}
              >
                {item.label}
              </Button>
            );
          })}
        </Group>
        </>
      )}
      <Outlet />
    </div>
  );
}
